import { getCascadeOfGoodsList } from '@/utils/comm-request'
import { setTreeData } from '@/utils/index'
import CONST from '@/utils/const'

const state = {
  goodsVer: 0,
  goodsData: [], // 带产品的cascade格式数据集
  goodsDataForSales: [], // 带产品的cascade格式数据集（只对外销售）
  goodsTypeList: [], // 产品类型列表
  goodsTypeListForSales: [], // 产品类型列表（只对外销售）
  goodsMapOfIdsArray: [], // 可按产品ID检索对应的idsArray（产品类型+产品ID的cascade数组数据格式）
  goodsMapOfNamesArray: [], // 可按产品ID检索对应的namesArray（产品名称的cascade数组数据格式）
  goodsMapOfId: [] // 可按产品ID检索对应的产品对象
}

const mutations = {
  init: (state, { goodsData, goodsTypeList, goodsMapOfIdsArray, goodsMapOfNamesArray, goodsMapOfId }) => {
    state.goodsData = goodsData
    state.goodsDataForSales = []
    goodsData.forEach(goods => {
      if (goods.is_sell === 1) {
        state.goodsDataForSales.push(goods)
      }
    })
    state.goodsTypeList = goodsTypeList
    state.goodsTypeListForSales = []
    // 末级产品分类，并且可售卖
    setTreeData(goodsTypeList, (goodsType) => {
      if (!goodsType.children && goodsType.is_sell === CONST.YES_NO.find(type => type.name === '是').id) {
        state.goodsTypeListForSales.push(goodsType)
      }
    })
    state.goodsMapOfIdsArray = goodsMapOfIdsArray
    state.goodsMapOfNamesArray = goodsMapOfNamesArray
    state.goodsMapOfId = goodsMapOfId
  },
  setGoodsVer(state, goodsVer) {
    state.goodsVer = goodsVer
  }
}

const actions = {
  // 初始化产品信息
  init({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      getCascadeOfGoodsList().then(data => {
        commit('init', data)
        dispatch('tip/add', { key: Math.random(), name: '初始化产品信息成功.' }, { root: true })
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  setGoodsVer({ commit }, goodsVer) {
    commit('setGoodsVer', goodsVer)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/goods.js